import state from './state'
import DTEutils from '@/mixins/DTE'
import { stat } from 'fs';

const SALE_CUSTOMER = 'SC'
const SALE_EMPLOYEE = 'SE'
const totalPaid = function() {
    let total = 0
    var i
    for (i = 0; i < state.arrayPayments.length; i++) {
        total += parseInt(state.arrayPayments[i].payment)
    }
    return total.toString()
}

const totalSale = function() {
        return state.total
}

const totalToPay = function(state) {
    let response = null
    let substract = 0
    let resto = totalSale() - parseInt(totalPaid())
    if(state.arrayPayments!=[]){
        response = state.arrayPayments.find(element=>element.paymentMethod==1)
    }
    if(response){
        substract = parseInt(totalPaid())-response.payment
    }
    
    if(state.paymentMethod===1  && resto >9 && state.arrayPayments.length<1){
        return rounding(totalSale() - parseInt(totalPaid()))
    }else if(response && resto <9 && state.arrayPayments.length==1){
        return rounding(totalSale() - parseInt(totalPaid()))
    }
    else if(response && resto >9 && state.arrayPayments.length==1 && state.paymentMethod==1){
        return rounding(totalSale() - parseInt(totalPaid()))
    }
    else{
        return (totalSale() - parseInt(totalPaid()))
    }
    
}


const change = function(state) {
    let response = null
    if(state.arrayPayments!=[]){
        response = state.arrayPayments.find(element=>element.paymentMethod==1)
    }


    let totalPaidNum = parseInt(totalPaid())
    let totalToPayNum = totalSale()

    if(response && state.arrayPayments.length==1){
        totalToPayNum= rounding(totalSale())
    }

    if (totalPaidNum < totalToPayNum) {
        return 0
    } else {
        
        let changeNum = totalPaidNum - totalToPayNum
        return changeNum.toString()
    }
}

/**
 * Returns true if al data necesary for confirming sale is set, false if any data is missing.
 */
const allDataSet = function() {
   
    if(parseInt(state.payment) === 0){
        return false
    }
    if (state.paymentMethod === 1) {
        // Cash payment:
        return state.payment != ''
    } else {
        // Other payment methods:
        return state.payment != '' && state.paymentDetail != null
    }
}

const subTotal = function() {
    let sub = 0
    if(state.saleDetail !=null){
        if (state.payer == SALE_EMPLOYEE && (state.paymentMethod ===1 || state.paymentMethod===null) ){
            state.saleDetail.map((detail)=>{
                sub+= detail.new_net_subtotal
            })
        } else {
            state.saleDetail.map(detail => {
                sub += detail.total
            })
        }
    }
    return sub
}


const amountDiscount = function (state,getters){
    return DTEutils.percentage(parseInt(state.discountOrChargePercentage),parseInt(getters.subTotal))
    
}

const roundingLaw = function (state, getters){
    return rounding(totalSale())-totalSale()
}

const rounding = function (amount){
    let resto = amount % 10
    if (resto <6) {
        return amount-resto
    }
    return amount +10 - resto
}


export default {
    change,
    totalToPay,
    allDataSet,
    totalPaid,
    totalSale,
    subTotal,
    amountDiscount,
    roundingLaw,
}
